module.exports = __webpack_public_path__ + "static/media/rm_06-23.73537d33.png";